import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { renderRoutes } from 'react-router-config';

import { env } from '../../helpers/env';

const GoogleRecaptchaV3 = ({ route: { routes } }) => (
  <GoogleReCaptchaProvider reCaptchaKey={env('RAZZLE_GOOGLE_RECAPTCHA_ENTERPRISE_PUBLIC_KEY')} useEnterprise={true}>
    {renderRoutes(routes)}
  </GoogleReCaptchaProvider>
);

export default GoogleRecaptchaV3;
